import 'rxjs';
import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import Root from 'root/Root';
import { APP_STARTED } from 'application/applicationActions';
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import configureStore from './configureStore';

// registerServiceWorker();
unregister();

const store = configureStore();
const rootElement = document.getElementById('root');

render(
  <AppContainer>
    <Root store={store} />
  </AppContainer>,
  rootElement,
);

store.dispatch({
  type: APP_STARTED,
});

if (module.hot) {
  module.hot.accept('./root/Root', () => {
    const NextRoot = require('./root/Root').default;
    render(
      <AppContainer>
        <NextRoot store={store} />
      </AppContainer>,
      rootElement,
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js